import apiClient from "./axios"

export const getAccountAccountTypeList = async (params = {}) => {
  const { data } = await apiClient.get("/account-account-types", { params })
  return data
}

export const getAccountAccountTypeById = async id => {
  const { data } = await apiClient.get(`/account-account-types/${id}`)
  return data
}

export const createAccountAccountType = async payload => {
  const { data } = await apiClient.post("/account-account-types", payload)
  return data
}

export const updateAccountAccountType = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-account-types/${id}`, payload)
  return data
}

export const deleteAccountAccountType = async id => {
  const { data } = await apiClient.delete(`/account-account-types/${id}`)
  return data
}
